// extracted by mini-css-extract-plugin
export var actions = "_ms-5";
export var assistantBubble = "_ms-3";
export var assistantRow = "_ms-6";
export var bubble = "_ms-0";
export var humanAvatar = "_ms-4";
export var inlineToolCard = "_ms-1";
export var userBubble = "_ms-2";